// config.js
const urlPlaceholder = 'https://spr-vati-web.azurewebsites.net'

export default urlPlaceholder